import { useMutation, UseMutationOptions } from '@tanstack/react-query'

import { API_ENDPOINTS } from '../../../common/apiEndpoints'
import {
  ErrorResponse,
  InitConfirmOperationResponse,
  initConfirmOperationResponseSchema,
} from '../../../common/validations'
import { ResidentAppError } from '../../../common/error'

import { post } from 'api/apiClient'
import { rethrowIdentificationRequired } from 'utils/rethrowIdentificationRequired'

interface ResumePendingOperationVariables {
  nonce: string
}

export const useAPIResumePendingOperation = (
  contractUuid: string,
  locale: string,
  options?: UseMutationOptions<
    InitConfirmOperationResponse,
    ErrorResponse,
    ResumePendingOperationVariables
  >
) => {
  const { mutate, isSuccess, isError, error, data, isPending } = useMutation({
    mutationFn: ({ nonce }: ResumePendingOperationVariables) =>
      post(
        `${API_ENDPOINTS.CONTRACTS}/${contractUuid}/confirm-operation/resume`,
        {
          nonce,
          locale,
        },
        initConfirmOperationResponseSchema
      ),
    ...options,
  })

  if (isError) {
    rethrowIdentificationRequired(error)

    throw ResidentAppError.ClientError('CONFIRM_OPERATION_GENERIC_ERROR')
  }

  return {
    mutate,
    isSuccess,
    data,
    isPending,
  }
}
